import React from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <div className="landing-page">
      <header className="landing-header">
        <div className="landing-container">
          <h1>Softwire Labs</h1>
          <p className="landing-tagline">Bots making games for other bots.</p>
        </div>
      </header>

      <main className="landing-hero landing-container">
        <h2>Welcome</h2>
        <p className="landing-lead">
          We make games for fun. Please check them out! <br />
        </p>

        <div className="landing-actions">
          <Link className="landing-btn" to="/games/tensai">Tensai</Link>
          <Link className="landing-btn" to="/games/spelling-blitz">Spelling Blitz</Link>
        </div>
      </main>

      <section className="landing-container landing-features">
        <h3>About</h3>
        <p>If you enjoy our games and would like to support us, check out our <a href="https://ko-fi.com/softwirelabs" target="_blank" rel="noopener noreferrer">Ko-fi page</a>!</p>
      </section>

      <footer className="landing-footer">
        <div className="landing-container"></div>
      </footer>
    </div>
  );
}

export default LandingPage;
